import { Quote } from 'lucide-react';
import Reveal from '@/components/Reveal';

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-[#F7F4EE] py-24 md:py-36 overflow-hidden"
    >
      <div
        className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full opacity-[0.06]"
        style={{ background: 'radial-gradient(circle, #B68A35 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="overline text-[#B68A35] mb-6">Why Bowers Advisory Group</div>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif text-[#0E2238] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-8">
                We Start With Your <span className="italic">Story</span>,<br />
                Not a Product.
              </h2>
            </Reveal>
            <Reveal delay={240}>
              <p className="text-[#2B2B2B]/80 text-base md:text-lg leading-[1.75] font-light mb-6">
                Every financial decision carries a story: your family, your responsibilities, your calling,
                and the future you hope to build.
              </p>
            </Reveal>
            <Reveal delay={340}>
              <p className="text-[#2B2B2B]/80 text-base md:text-lg leading-[1.75] font-light">
                Bowers Advisory Group begins with education, clarity, and a strategy designed
                around your life. Not a template. Not a pitch. A conversation.
              </p>
            </Reveal>
            <Reveal delay={440}>
              <div className="gold-line mt-12 w-24" />
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={200}>
              <div className="relative bg-[#0E2238] p-10 md:p-12 rounded-sm border border-[#B68A35]/30 shadow-[0_40px_100px_-40px_rgba(14,34,56,0.4)]">
                <Quote className="absolute top-6 left-6 w-8 h-8 text-[#B68A35]/50" strokeWidth={1} />
                <div className="pt-8">
                  <p className="pull-quote text-[#F7F4EE] text-2xl md:text-3xl leading-[1.25] mb-8">
                    "We do not begin with products.<br />
                    We begin with <span className="gold-text not-italic">purpose</span>."
                  </p>
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-px bg-[#B68A35]" />
                    <div>
                      <p className="text-[#D6B36A] text-sm tracking-[0.2em] uppercase font-medium">Anthony Bowers</p>
                      <p className="text-white/50 text-xs mt-1 tracking-wide">Founder & Financial Consultant</p>
                    </div>
                  </div>
                </div>
                <div className="absolute -bottom-px -right-px w-16 h-16 border-r border-b border-[#D6B36A]" />
                <div className="absolute -top-px -left-px w-16 h-16 border-l border-t border-[#D6B36A]" />
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
